<template>
  <card v-if="productInstance">
    <template slot="header">
      <h4 class="card-title">#{{ productInstance.id }}</h4>
    </template>
    <div>
      <p>
        Produkt/Variation:
        <router-link :to="`/products/${productInstance.product_id}`">
          {{ productInstance.product.name }} <span v-if="productInstance.product.stringRepShort">({{ productInstance.product.stringRepShort.join(' | ') }})</span>
        </router-link>
      </p>
      <h5>Lagerbewegungen</h5>
      <table class="table table-striped table-bordered" v-if="productInstance.stock_rotations.length">
        <thead>
          <tr>
            <th>Datum</th>
            <th>Lager</th>
            <th>Preis</th>
            <th>Grund</th>
            <th>User</th>
            <th>Kostenstelle</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="stockRotation in productInstance.stock_rotations"
            :key="stockRotation.id"
          >
            <td>{{ stockRotation.created_at | datetime }}</td>
            <td>{{ stockRotation.warehouse.name }}</td>
            <td>{{ stockRotation.price | priceFromCentEuro }}</td>
            <td :class="getDirectionClass(stockRotation)">{{ stockRotation.cause ? stockRotation.cause.name : '' }}</td>
            <td>{{ stockRotation.user ? stockRotation.user.name : '' }}</td>
            <td>{{ stockRotation.cost_center ? stockRotation.cost_center.name : '' }}</td>
            <td>
              <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                 @click="deleteStockRotation(stockRotation)">
                <i class="fa fa-close"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <p v-else>Keine Lagerbewegungen für dieses Produkt vorhanden</p>
    </div>
  </card>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      productInstance: null
    }
  },
  methods: {
    getDirectionClass (stockRotation) {
      if (stockRotation.cause.direction === 1) {
        return 'rotation-in'
      } else if (stockRotation.cause.direction === -1) {
        return 'rotation-out'
      } else {
        return ''
      }
    },
    async deleteStockRotation (stockRotation) {
      if (confirm('Lagerbewegung wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/stock_rotations/${stockRotation.id}`).then(({ data }) => {
          this.$notify({
            message: `Lagerbewegung erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.productInstance.stock_rotations.findIndex(({ id }) => data.id === id)
          this.productInstance.stock_rotations.splice(index, 1)
        })
      }
    }
  },
  created () {
    this.$http.get(`/product_instances/${this.$route.params.id}`).then(({ data }) => {
      this.productInstance = data
    })
  }
}
</script>

<style>
</style>
